module.exports = __webpack_public_path__ + "img/logo_navbar.4977abb4.png";